import { useTranslation } from 'react-i18next';

import { Box, Card, Text } from '@highlight-cp/core-ui';
import { ExternalLink, HighlightLogo } from '@highlight-cp/core-ui-compositions';

import classes from './AuthUIWrapper.module.css';

interface AuthUIWrapperProps {
  children: React.ReactNode;
  // Off for pages, like the 404, where agreeing to terms makes no sense.
  showTerms?: boolean;
}

const AuthUIWrapper = ({ children, showTerms = true }: AuthUIWrapperProps) => {
  const { t } = useTranslation();

  return (
    <Box className={classes.root}>
      <HighlightLogo width={200} height="auto" />
      <Card p="xl" w={400}>
        {children}
      </Card>
      {showTerms && (
        <Box ta="right" className={classes.tos}>
          <Text size="sm">
            {t('By using Highlight you agree to our')}{' '}
            <ExternalLink href="https://www.letshighlight.com/brand-terms-of-service">
              {t('Terms of Service')}
            </ExternalLink>
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default AuthUIWrapper;
